import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text, Box, Image } from 'rebass/styled-components';
import IconHandEmpty from 'assets/icon-hand-empty.svg';
import { FieldItem } from './fieldItem';
import { AddFieldDropdown } from './addFieldDropdown';

export const FieldsSection = ({
  fields,
  onAddField,
  onUpdateField,
  onDeleteField,
  onReorderFields,
  lastAddedFieldId,
  onClearLastAddedFieldId,
}) => (
  <Flex sx={{ flexDirection: 'column', gap: '8px', width: '100%' }}>
    <Text
      sx={{
        fontSize: '12px',
        fontWeight: '500',
        color: 'text.subtle',
        textTransform: 'uppercase',
        letterSpacing: '1px',
      }}
    >
      Fields
    </Text>
    {fields.length === 0 ? (
      <Box
        sx={{
          p: '32px',
          textAlign: 'center',
          border: '1px dashed',
          borderColor: 'border.subtle',
          borderRadius: '4px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '16px',
        }}
      >
        <Image src={IconHandEmpty} alt="" width="64px" height="64px" />
        <Text sx={{ fontSize: '14px', color: 'text.main', fontWeight: '600' }}>Your form needs at least one field</Text>
        <AddFieldDropdown onAddField={onAddField} />
      </Box>
    ) : (
      <Flex sx={{ flexDirection: 'column', gap: '8px' }}>
        {fields.map((field, index) => (
          <FieldItem
            key={field.id}
            field={field}
            index={index}
            onUpdate={(updates) => onUpdateField(field.id, updates)}
            onDelete={() => onDeleteField(field.id)}
            onReorder={onReorderFields}
            autoFocusLabel={field.id === lastAddedFieldId}
            onLabelFocused={field.id === lastAddedFieldId ? onClearLastAddedFieldId : undefined}
          />
        ))}
        <AddFieldDropdown onAddField={onAddField} />
      </Flex>
    )}
  </Flex>
);

FieldsSection.propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      type: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      required: PropTypes.bool.isRequired,
    }),
  ).isRequired,
  onAddField: PropTypes.func.isRequired,
  onUpdateField: PropTypes.func.isRequired,
  onDeleteField: PropTypes.func.isRequired,
  onReorderFields: PropTypes.func.isRequired,
  lastAddedFieldId: PropTypes.string,
  onClearLastAddedFieldId: PropTypes.func.isRequired,
};

FieldsSection.defaultProps = {
  lastAddedFieldId: null,
};
